<form novalidate #motorsListingDetailsContactSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <tg-row>
      <tg-col>
        <tg-row>
          <tg-col sm="12">
            <h1 class="motors-listing-details-contact-section__title">
              Your contact details
            </h1>
          </tg-col>
        </tg-row>
        @if (draftData.listingDetails.mobileNumber || draftData.listingDetails.landlineNumber) {
          <tg-row>
            <tg-col>
              <tg-checkbox-group label="Check the phone numbers to display on your listing"
                class="hide-optional-label">
                @if (draftData.listingDetails.mobileNumber) {
                  <tg-checkbox name="mobilePhone"
                    (change)="publish()" [(ngModel)]="draftData.listingDetails.displayMobileNumber"
                    [disabled]="disableCheckBox">
                    <tg-label>{{ draftData.listingDetails.mobileNumber | tmPhoneNumberFormat }} (mobile)</tg-label>
                  </tg-checkbox>
                }
                @if (draftData.listingDetails.landlineNumber) {
                  <tg-checkbox name="landline"
                    (change)="publish()" [(ngModel)]="draftData.listingDetails.displayLandlineNumber"
                    [disabled]="disableCheckBox">
                    <tg-label>{{ draftData.listingDetails.landlineNumber | tmPhoneNumberFormat }} (landline)</tg-label>
                  </tg-checkbox>
                }
              </tg-checkbox-group>
            </tg-col>
          </tg-row>
        }
        <tg-row>
          <tg-col>
            <a [innerHTML]="draftData.listingDetails.landlineNumber || draftData.listingDetails.mobileNumber ? 'Edit contact numbers' : 'Add contact numbers'"
            (click)="openModal()"></a>
          </tg-col>
        </tg-row>
      </tg-col>
    </tg-row>
  }
  @if (showModal) {
    <tm-contact-modal (closeModal)="closeModal()"
      [mobilePhoneNumberValidator]="validation.listingDetails.mobileNumber | disallowEmptyIf: hasBids && draftData.listingDetails.displayMobileNumber"
    [landlineNumberValidator]="validation.listingDetails.landlineNumber | disallowEmptyIf: hasBids && draftData.listingDetails.displayLandlineNumber"></tm-contact-modal>
  }
</form>